<ng-container *transloco="let t">
  <!-- Checkbox -->
  @if (this.config().fieldType === 'checkbox') {
    <div class="form-group __multiline">
      <mat-checkbox [formControl]="field">
        <span [innerHTML]="getLocalization('label')"></span>
      </mat-checkbox>
      @if (field.invalid && field.dirty) {
        <div
          class="message __error"
          role="alert">
          @if (field.errors.required) {
            {{ t('common.required') }}
          }
        </div>
      }
    </div>
  }
</ng-container>
